export const data = {
  login: (user: { uuid: string; email: string; name: string | null; surname: string | null }) => ({
    event: 'auth_login',
    user: {
      uuid: user.uuid,
      email: user.email,
      name: [user.name, user.surname].join(' '),
    },
  }),
  logout: () => ({
    event: 'auth_logout',
  }),
}
